module.exports = __webpack_public_path__ + "img/3.d42e7102.jpg";